/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  if (window.location.hash) {
    const href = window.location.href;
    let URL = window.location.href.split('#');

    if (typeof URL[1] != undefined && typeof URL[1] != 'undefined' && URL[1] != '') {
      setTimeout(() => {
        let element = document.querySelector(`.${URL[1]}`);
        let offset = element.offsetTop;
        let navigation = document.querySelector('#NavStandard').clientHeight;
        let scroll = offset + navigation;
        window.scrollTo(0, scroll);
      }, 1000);
    }
  }

  document.querySelectorAll('a').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      let URL = event.target.href.split('#');
  
      if (typeof URL[1] != undefined && typeof URL[1] != 'undefined' && URL[1] != '') {
        let element = document.querySelector(`.${URL[1]}`);
        let offset = element.offsetTop;
        let navigation = document.querySelector('#NavStandard').clientHeight;
        let scroll = offset + navigation;
        window.scrollTo(0, scroll);
        event.preventDefault(); // avoid internal scroll to anchor
      }
    });
  });

  const headingAnimatedEls = document.querySelectorAll('[data-heading-animated]');

  headingAnimatedEls.forEach((el) => {
    const count = parseInt(el.getAttribute('data-heading-animated'));
    const items = el.querySelectorAll('[data-heading-animated-item]');
    let index = 1;

    setInterval(() => {
      items[index].classList.add('animated');

      setTimeout(() => {
        items[index].classList.remove('animated');
      }, 3200);

      if (index < count - 1) {
        index++;
      } else {
        index = 0;
      }
    }, 3200);
  });

  document.querySelectorAll('.js-benefit-toggle').forEach((benefit) => {
    benefit.addEventListener('click', (event) => {
      event.preventDefault();

      benefit.classList.toggle('open');
    });
  });

  const handleHeaderScroll = () => {
    const body = document.body
    let oldScrollY = window.scrollY
  
    document.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY
      const isScrollingUp = currentScrollY < oldScrollY && currentScrollY > 0
      const isScrollingDown = currentScrollY > oldScrollY

      if (currentScrollY === 0) {
        body.classList.remove('has-scrolled-down')
      } else {
        if (isScrollingUp) {
          body.classList.remove('has-scrolled-down')
        }
        if (isScrollingDown) {
          body.classList.add('has-scrolled-down')
        }
      }

      oldScrollY = currentScrollY
    })
  }

  handleHeaderScroll()

  document.querySelectorAll('.js-tier-atc-button, .js-image-with-text-atc-button, .js-sticky-images-and-text-atc-button').forEach((tierButton) => {
    tierButton.addEventListener('click', (event) => {
      event.preventDefault();

      const variantId = tierButton.getAttribute('data-variant-id');

      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };
       
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

      setTimeout(function() {
        SLIDECART_UPDATE();
        SLIDECART_OPEN();
      }, 1000)

      setTimeout(function() {
        SLIDECART_UPDATE();
      }, 2000)
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
